import { baseTheme } from '~base-theme';
import alertTheme from './alertTheme';
var alertDarkTheme = {
  alert: Object.assign({}, alertTheme.alert, {
    alertFeedback: {
      backgroundColor: baseTheme.base.colors.dark
    }
  })
};
export default alertDarkTheme;